import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { FlexColumn } from '@elementary/common-ui/components';
import { getWarehouseIcon } from '@elementary/common-ui/utils/environments';
import useEnvironments from 'shared/hooks/useEnvironments';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import { PermissionsAccess, RoleFormData } from '../../shared/types';
import {
  SimpleEnvironmentItem,
  AccordionEnvironmentItem,
} from './EnvironmentPermissionItem';

const EnvironmentsPermissionList = ({ disabled }: { disabled?: boolean }) => {
  const { data: environmentsData } = useEnvironments();
  const { data: accountData } = useAccount();
  const { watch } = useFormContext<RoleFormData>();

  const environments = useMemo(
    () => environmentsData || [],
    [environmentsData],
  );
  const defaultAccess =
    watch('newEnvironmentDefaultAccess') || PermissionsAccess.HIDDEN;

  const resourcePermissionsEnabled =
    accountData?.resource_permissions_enabled || false;

  if (environments.length === 0) {
    return null;
  }

  const EnvironmentItemComponent = resourcePermissionsEnabled
    ? AccordionEnvironmentItem
    : SimpleEnvironmentItem;

  return (
    <FlexColumn>
      {environments.map((env, index) => {
        const WarehouseIcon = getWarehouseIcon(env.dwhConnection.warehouseType);

        return (
          <EnvironmentItemComponent
            key={env.id}
            environmentId={env.id}
            environmentName={env.name}
            warehouseIcon={WarehouseIcon}
            index={index}
            defaultAccess={defaultAccess}
            disabled={disabled}
          />
        );
      })}
    </FlexColumn>
  );
};

export default EnvironmentsPermissionList;
